import {
  CampaignAddRequest,
  IntegrationCampaign,
  IntegrationType,
} from '@aibees/elephant/types/integration';
import { HttpMethod } from '@aibees/shared/definition';
import { baseQueryClient, useBaseMutation } from '@aibees/shared/http';
import { useWorkspace } from '@aibees/shared/workspace';
import { INTEGRATION_API_PREFIX } from './constants';
import { useBrowseIntegrationApi } from './use-browse-integration-api';
import { useBrowseIntegrationCountApi } from './use-browse-integration-count-api';

export function useAddCampaignMutationApi(type?: IntegrationType, id?: string) {
  const workspace = useWorkspace();

  return useBaseMutation<CampaignAddRequest, IntegrationCampaign>(
    {
      url: `${INTEGRATION_API_PREFIX.replace(
        ':wid',
        String(workspace?.id)
      )}/${type}/${id}/campaigns`,
      method: HttpMethod.post,
    },
    {
      onSettled() {
        baseQueryClient.invalidateQueries([useBrowseIntegrationCountApi.name]);
        baseQueryClient.invalidateQueries([
          useBrowseIntegrationApi.name,
          0,
          {
            size: 25,
          },
        ]);
      },
    }
  );
}
